<template>
  <div>
    <FormAddFavoris @addFavoris="addFavoris"></FormAddFavoris>
    <ListFavoris :favoris="favoris" @removeFavoris="removeFavoris"></ListFavoris>
  </div>
</template>

<script>
import FormAddFavoris from "@/components/Live_tab/FormAddFavoris.vue";
import ListFavoris from "@/components/Live_tab/ListFavoris.vue";
export default {
  components: { FormAddFavoris, ListFavoris },
  data() {
    return {
      favoris: [],
    };
  },
  methods: {
    removeFavoris(index) {
      this.favoris.splice(index, 1);
      this.$cookies.set("favorites_" + this.$store.state.module.base, this.favoris);
    },
    addFavoris(id) {
      if (!this.favoris.includes(id)) {
        this.favoris.push(id);
      }
      this.$cookies.set("favorites_" + this.$store.state.module.base, this.favoris);
    },
  },
  mounted() {
    let key = "favorites_" + this.$store.state.module.base;

    if (this.$cookies.isKey(key)) {
      let favs = this.$cookies.get(key);
      if (favs) {
        this.favoris = favs.split(",");
      } else {
        this.$cookies.set(key, []);
      }
    } else {
      this.$cookies.set(key, []);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>